module.exports = __webpack_public_path__ + "img/public/SiteIcons/adminPlusIcon.svg?e512e35b";